/**
 * The page numbers a `Pagination` footer shows: a sliding window of five
 * around the current page — the frame draws exactly five number buttons, kept
 * centred where it can be and pinned to either end where it cannot. Ported from
 * the prototype's `views/tables/pageWindow.ts`.
 */
export const PAGE_WINDOW = 5;

export function pageWindow(page: number, pageCount: number, size: number = PAGE_WINDOW): number[] {
  const count = Math.min(size, pageCount);
  const start = Math.min(Math.max(1, page - Math.floor(count / 2)), pageCount - count + 1);
  return Array.from({ length: count }, (_, i) => start + i);
}
